module.exports = __webpack_public_path__ + "img/menu_icon.d343c33.png";